<template>
  <footer class="site-footer">
    <div class="footer-inner shell">
      <div class="footer-about">
        <RouterLink class="footer-brand" to="/">
          <img
            src="@/assets/bluespeedlogo-transparent.png"
            alt="Blue Speed Construction Pte Ltd"
          />
        </RouterLink>

        <div class="footer-certs">
          <img
            src="@/assets/bizsafestar.jpg"
            alt="bizSAFE Star certified"
            loading="lazy"
          />
          <img
            src="@/assets/iso_bizasafe.jpg"
            alt="SOCOTEC ISO 45001 — SAC Accredited Certification Body OSH-2008-01"
            loading="lazy"
          />
        </div>
      </div>

      <div class="footer-columns">
        <div>
          <strong>Company</strong>
          <RouterLink to="/about">About Us</RouterLink>
          <RouterLink to="/about#journey">Our Journey</RouterLink>
          <RouterLink to="/quality-safety">Quality, Safety &amp; Training</RouterLink>
          <RouterLink to="/testimonial">Testimonials</RouterLink>
        </div>

        <div>
          <strong>What we do</strong>
          <RouterLink to="/services">Services</RouterLink>
          <RouterLink to="/our-work">Our Work</RouterLink>
          <RouterLink to="/divisions">Building &amp; Civil Division</RouterLink>
          <RouterLink to="/divisions#rope-access">Rope Access Division</RouterLink>
          <RouterLink to="/divisions#rope-access-capability">Rope Access Capability</RouterLink>
        </div>

        <div>
          <strong>Get in touch</strong>
          <RouterLink to="/contact">Contact Us</RouterLink>
          <a :href="whatsappUrl" target="_blank" rel="noopener noreferrer">WhatsApp</a>
        </div>
      </div>
    </div>

    <div class="footer-bottom shell">
      <span>© {{ currentYear }} Blue Speed Construction Pte. Ltd. All rights reserved.</span>
      <span>Building maintenance · Building and civil works · Rope access services</span>
    </div>
  </footer>
</template>

<script>
import { whatsappLink } from "@/config/company";

export default {
  name: "SiteFooter",

  data() {
    return {
      whatsappUrl: whatsappLink(),
    };
  },

  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scoped>
.site-footer {
  position: relative;
  z-index: 2;
  padding: 70px 0 28px;
  border-top: 1px solid rgba(11, 37, 69, 0.08);
  background: #f4f8fc;
}

.footer-inner {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 72px;
}

.footer-brand {
  display: inline-flex;
}

.footer-brand img {
  width: 235px;
  max-height: 52px;
  object-fit: contain;
  object-position: left center;
}

.footer-certs {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 18px;
  max-width: 470px;
  margin: 22px 0 0;
}

.footer-certs img {
  width: auto;
  height: 58px;
  max-width: 100%;
  object-fit: contain;
}

.footer-columns {
  display: grid;
  grid-template-columns: repeat(3, minmax(140px, auto));
  gap: 48px;
}

.footer-columns > div {
  display: grid;
  align-content: start;
  gap: 12px;
}

.footer-columns strong {
  margin-bottom: 4px;
  color: #0b2545;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.footer-columns a {
  color: #5b7590;
  font-size: 12px;
  text-decoration: none;
  transition: color 160ms ease;
}

.footer-columns a:hover {
  color: #0b5dbb;
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-top: 56px;
  padding-top: 22px;
  border-top: 1px solid #d8e4ee;
  color: #7c90a5;
  font-size: 10px;
}

@media (max-width: 1080px) {
  .footer-inner {
    grid-template-columns: 1fr;
    gap: 44px;
  }
}

@media (max-width: 760px) {
  .footer-certs img {
    height: 46px;
  }

  .footer-columns {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 32px;
  }

  .footer-bottom {
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .footer-columns {
    grid-template-columns: 1fr;
  }
}
</style>
